export enum AddPhoneNumberMappingCommand {
  ALL,
  ALL_INTERNAL,
  ALL_FIXED_NETWORK,
  ALL_MOBILE,
  SINGLE,
}
